import { render } from "./CustomImage.vue?vue&type=template&id=63b452ba"
import script from "./CustomImage.vue?vue&type=script&lang=js"
export * from "./CustomImage.vue?vue&type=script&lang=js"

import "./CustomImage.vue?vue&type=style&index=0&id=63b452ba&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__